import { ArcButton } from '@src/core/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setOrderFormData, setAssignMethod } from '@src/features/order/pages/orders-page/redux';
import { UpdateNewOrderButtonProps } from './types';
import { routesConfig } from '@src/core/routes';

export const ASSIGN_METHOD_VALUES = {
  MANUAL: 'manual',
  AUTO: 'auto',
} as const;


const UpdateNewOrderButton: React.FC<UpdateNewOrderButtonProps> = (props) => {
  const { order } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onEdit = () => {
    if (order) {
      dispatch(setOrderFormData(order));
    }
    const orderAssignMethod = order?.assignMethod || ASSIGN_METHOD_VALUES.AUTO;
    dispatch(setAssignMethod(orderAssignMethod));
    const serial = order?.drone?.serialNumber;
    const query = serial ? `?droneSerial=${serial}` : '';
    navigate(`${routesConfig.orders}/update/${order.id}${query}`);
  };

  return (
    <ArcButton.ghost
      fullWidth 
      onClick={onEdit}> 
        Edit 
    </ArcButton.ghost>
  );
};

export default UpdateNewOrderButton;